
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { BiLoaderCircle } from "react-icons/bi";
import toast from "react-hot-toast";
import moment from "moment";

import CustomModal from "../../../common/CustomModal";
import CustomButton from "../../../common/CustomButton";

import { UpdateUserPlan, LoadUserBillingData, ReactivateSubscription, } from "../../../redux/v2/user/actions";
import { convertCurrencySymbols } from "../../../constants"
import { apiCallV2 } from "../../../utils/api";

function Subscription(props) {

    const { account } = props.User;
    const billing = account?.billingInfo;
    const [planArray, setPlanArray] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({
        index: -1,
        info: {},
    });

    const label = {
        "1": {
            text1: "Monthly",
            text2: "Month",
        },

        "12": {
            text1: "Annual",
            text2: "Year",
        },
    }

    const getPlan = async () => {
        const res = await apiCallV2("GET", "get-subscription-plans");
        if (res.status === 200) {
            setPlanArray(res.data.data);

        }
    };

    useEffect(() => {
        getPlan();
    }, []);

    const isCancelled = billing.hasCanceledSubscription;
    if (billing.hasOwnProperty("createdAt") && selectedPlan.index == -1 && !isCancelled && planArray.length > 1) {

        const tempPlan = { ...planArray.filter(p => p.id == billing.plan.id)[0] };

        setSelectedPlan({
            index: 1,
            info: { ...tempPlan }
        });
    }


    const billingPlan = billing.plan;

    const Delay = (cb, time = 1000) => {
        let timer = setTimeout(() => {
            cb();
            clearTimeout(timer);
        }, time)
    }

    const [currentButton, setCurrentButton] = useState(0);
    let planChange = false;

    if (selectedPlan.info.code && !isCancelled) {
        planChange = billing.hasOwnProperty("createdAt") ? selectedPlan.info.code.split("-")[0] != billingPlan.code.split("-")[0] : false;
    } else if (selectedPlan.info.code && isCancelled) {
        planChange = true;
    }

    let identifiedPlans = ["monthly-renewal", "annual-plan-renewal"];
    const currentPlanType = billing.hasOwnProperty("createdAt") ? { ...planArray.filter(p => p.id == billing.plan.id)[0] } : null;

    if (billing.hasOwnProperty("createdAt")) {
        identifiedPlans[currentPlanType.interval_length == 1 ? 0 : 1] = currentPlanType.code;
    }

    let monthly = 0;
    const buttons = [
        <CustomButton
            onClick={() => {
                setCurrentButton(2);

                if (isCancelled) {
                    Delay(() => {
                        setCurrentButton(1);
                    }, 500);

                } else {
                    Delay(() => {
                        setShowModal(true);
                    }, 500);
                }
            }}
            disabled={!planChange}
        >
            {isCancelled ? "REACTIVATE PLAN" : "UPDATE"}
        </CustomButton>,

        <CustomButton
            onClick={async () => {
                setCurrentButton(2);

                if (isCancelled) { ///Reactivate Subscription

                    const res = await props.ReactivateSubscription();

                    if (res.success) {
                        props.LoadUserBillingData();
                        setCurrentButton(0);

                        toast.success("Plan successfully reactivated");
                    } else {
                        toast.error("Failed to reactivate plan");
                    }
                }
            }}
        >
            CONFIRM?
        </CustomButton>,

        <CustomButton>
            <BiLoaderCircle className="btn-loading" style={{ margin: "0" }} />
        </CustomButton>,

        <CustomButton>
            SAVED!
        </CustomButton>,
    ];

    const [showModal, setShowModal] = useState(false);

    const isComplete = billing.hasOwnProperty("createdAt");


    const dt = localStorage.getItem("indi-device-type");
    const platform = localStorage.getItem("indi-platform");
    const isUsingApp = platform && (platform === "ios-app" || platform === "android-app")
    // const isUsingApp = (dt === "ios" || dt === "android" || dt === "mobile" || dt === "tablet")

    const status = account?.user?.company ? "ACTIVE" : (isComplete
        ? isCancelled
            ? `ACTIVE UNTIL ${(moment(new Date(billing.currentPeriodEndsAt)).format("ll") + "").toUpperCase()}`
            : "ACTIVE"
        : "----");
    const expiry = account?.user?.company ? "N/A" : (isComplete
        ? isCancelled
            ? "NONE"
            : moment(new Date(billing.currentPeriodEndsAt)).format("L")
        : "----");

    return (
        <div id="billing-form" className="my-account-form" style={{ paddingTop: "10px" }}>

            <CustomModal
                toggle={() => {
                    setShowModal(!showModal)
                }}
                preToggle={() => {
                    setCurrentButton(0);
                }}
                id="change-plan-modal"
                show={showModal}
                title="CONFIRM CHANGES"
                body={
                    <>
                        <div id="confirm-message">
                            <p>
                                {`Your account will change to ${label[selectedPlan.info.interval_length + ""]?.text1} billing. You will be charge ${convertCurrencySymbols(selectedPlan.info.currency) + "" + selectedPlan.info.amount} per ${label[selectedPlan.info.interval_length + ""]?.text2} at your next billing cycle.`}
                            </p>
                            <p mt="25px">
                                Next Bill Date: {moment(new Date(billing.currentTermStartedAt)).format("LL")}
                            </p>
                        </div>
                    </>
                }
                footerButtons={
                    [
                        {
                            label: "Confirm",
                            action: async () => {
                                setShowModal(false);

                                let res;

                                if (selectedPlan.info.id == billing.plan.id) {
                                    res = await props.ReactivateSubscription();
                                } else {
                                    res = await props.UpdateUserPlan({ planID: selectedPlan.info.id });
                                }

                                if (res.success) {
                                    Delay(() => {
                                        props.LoadUserBillingData();

                                        toast.success("Plan changed successfully");
                                        setCurrentButton(0);
                                    }, 1000);
                                } else {
                                    toast.error("Failed to change plan");
                                    setCurrentButton(0);
                                }

                            },
                            className: "btn-black",
                        }

                    ]
                }
            />

            <div className="row">
                <div className="col-md-12">
                    <h4>CURRENT PLAN</h4>
                </div>

                <div className="col-md-12 mb-5">
                    <div className="row">
                        <div className="col-md-6 acc-detail">
                            <p>STATUS:</p>
                            <p>{status}</p>
                        </div>
                        <div className="col-md-6 acc-detail">
                            <p>CURRENT PLAN: </p>
                            <p>PROMO - ({billing?.coupon?.length ? billing?.coupon[0]?.coupon?.code : ""})</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 acc-detail">
                            <p>EXPIRES:</p>
                            <p>{expiry}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

const mapStateToProps = (state) => ({
    User: state.User
});

export default connect(mapStateToProps, {
    UpdateUserPlan,
    LoadUserBillingData,
    ReactivateSubscription,
})(Subscription);
